import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { AuthService } from '../services/auth.service';
import * as moment from 'moment';
import { environment } from '../../environments/environment';
import { SnotifyService } from 'ng-snotify';

@Injectable()
export class ExpiredReportService {
  constructor(private http: HttpClient, private authService: AuthService, private snotifyService: SnotifyService) { }

  public getResults(page: Page, company_Id: number, expiry_Status: number, is_Client: boolean, quick_Search: string): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Cylinder_ID'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '&company_Id=' + company_Id;
      params += '&expiry_Status=' + expiry_Status;
      params += '&quick_Search=' + quick_Search;

      var is_Client = this.authService.currentUser.value.userType == 0;
      params += '&is_Client=' + is_Client;

      this.http.get<ServerData>(environment.apiUrl + 'expired/GetTable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        console.log(data);
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    });
    return blob;
  }


  public getExcel(company_Id: number, expiry_Status: number, is_Client: boolean, sortBy, sortOrder, quick_Search): Promise<any> {

    return new Promise((resolve, reject) => {

      let params = '?company_Id=' + company_Id;
      params += '&expiry_Status=' + expiry_Status;

      var is_Client = this.authService.currentUser.value.userType == 0;
      params += '&is_Client=' + is_Client;
      params += '&sortBy=' + sortBy;
      params += '&sortOrder=' + sortOrder;
      params += '&quick_Search=' + quick_Search;

      this.http.get<any>(environment.apiUrl + 'expired/GetExcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

}
